import React from "react";
import Automatedreplies from "../../../../images/LandingPageImage/automated_replies_and_smart_flow_1x.webp";
import Whatsappcamp from "../../../../images/LandingPageImage/whatsapp_campaign_1x.webp";
import Templatecreation from "../../../../images/LandingPageImage/template_creation_1x.webp";
import Auidencetracking from "../../../../images/LandingPageImage/audience_tracking_1x.webp";
import { FcGoogle } from "react-icons/fc";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "../designcss/Features.css";

function Features() {
  const navigate = useNavigate();
  return (
    <section className="advanced-features">
      <header className="features-header">
        <h2>Features</h2>
      </header>

      <div className="feature-grid">
        <div className="feature-image">
          <img
            src={Automatedreplies}
            alt="whatsapp"
            className="feature-main-img"
          />
        </div>

        <div className="feature-content">
          <h3 className="titleheading">WhatsApp Campaigns</h3>
          <h2 className="subtitle">
            Stay connected with your customers through fast, real-time WhatsApp
            communication.
          </h2>
          <ul>
            <li>
              Send order confirmations, reminders, alerts, and important updates
              instantly
            </li>
            <li>Respond faster and improve customer engagement</li>
            <li>Maintain continuous communication through WhatsApp</li>
          </ul>

          <div className="featuresss-buttonsss">
            <button
              className="readmoreee"
              onClick={() => navigate("/whatsapp-campaign")}
            >
              Read More <FaArrowRightLong />
            </button>
            <Link to= "/login">
            <button className="startfreee">
              <FcGoogle /> Start With Google
            </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="feature-grid reverse">
        <div className="feature-image">
          <img src={Whatsappcamp} alt="template" className="feature-main-img" />
        </div>
        <div className="feature-content">
          <h3 className="titleheading">WhatsApp Automation</h3>
          <h2 className="subtitle">
            Reduce manual work and streamline daily business tasks with smart
            automation.
          </h2>
          <ul>
            <li>
              Automate lead qualification, appointment booking, and follow-ups
            </li>
            <li>Ensure timely responses even outside working hours</li>
            <li>Save team time and improve overall efficiency</li>
          </ul>

          <div className="featuresss-buttonsss">
            <button
              className="readmoreee"
              onClick={() => navigate("/audience-targating")}
            >
              Read More <FaArrowRightLong />
            </button>
            <Link to= "/login">
            <button className="startfreee">
              <FcGoogle /> Start with Google
            </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="feature-grid">
        <div className="feature-image">
          <img
            src={Templatecreation}
            alt="smartflow"
            className="feature-main-img"
          />
        </div>
        <div className="feature-content">
          <h3 className="titleheading">Analytics and Customer Data</h3>
          <h2 className="subtitle">
            Make better decisions with clear insights and organised
            conversations.Track performance while delivering
          </h2>
          <ul>
            <li>Monitor campaign performance and engagement levels</li>
            <li>Manage all conversations from a single dashboard</li>
            <li>
              Enable two-way communication for queries, feedback, and service
              requests
            </li>
          </ul>

          <div className="featuresss-buttonsss">
            <button
              className="readmoreee"
              onClick={() => navigate("/personalized-message")}
            >
              Read More <FaArrowRightLong />
            </button>
            <Link to= "/login">
            <button className="startfreee">
              <FcGoogle /> Start With Google
            </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="feature-grid reverse">
        <div className="feature-image">
          <img
            src={Auidencetracking}
            alt="tracking"
            className="feature-main-img"
          />
        </div>
        <div className="feature-content">
          <h3 className="titleheading">WhatsApp Chatbots</h3>
          <h2 className="subtitle">
            Scale communication without losing speed. Reach thousands of
            customers at once with automated WhatsApp messaging.
          </h2>
          <ul>
            <li>Send bulk messages instantly without delay</li>
            <li>Automate replies and common customer queries</li>
            <li>Improve outreach and boost campaign results</li>
          </ul>

          <div className="featuresss-buttonsss">
            <button className="readmoreee" onClick={() => navigate("/automated-replies")}>
              Read More <FaArrowRightLong />
            </button>
            <Link to= "/login">
            <button className="startfreee">
              <FcGoogle /> Start With Google
            </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
